import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin, FiLinkedin, FiInstagram, FiTwitter, FiYoutube } from 'react-icons/fi';

const Footer = () => (
  <footer>
    <style>{`
      footer { background: var(--dark); color: #cbd5e1; padding: 64px 0 0; }
      .footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1.5fr; gap: 48px; max-width: 1180px; margin: 0 auto; padding: 0 24px; }
      .footer-brand { }
      .footer-logo { display: flex; align-items: center; gap: 10px; font-family: var(--font-display); font-weight: 800; font-size: 22px; color: white; margin-bottom: 14px; }
      .footer-logo-icon { width: 36px; height: 36px; background: linear-gradient(135deg, var(--primary), var(--accent)); border-radius: 8px; display: flex; align-items: center; justify-content: center; color: white; font-weight: 800; font-size: 18px; }
      .footer-tagline { font-size: 14px; color: #94a3b8; line-height: 1.7; max-width: 280px; margin-bottom: 20px; }
      .footer-socials { display: flex; gap: 12px; }
      .footer-social { width: 36px; height: 36px; border-radius: 8px; background: var(--dark-2); display: flex; align-items: center; justify-content: center; color: #94a3b8; transition: var(--transition); }
      .footer-social:hover { background: var(--primary); color: white; transform: translateY(-2px); }
      .footer-col h4 { font-family: var(--font-display); font-size: 15px; font-weight: 700; color: white; margin-bottom: 16px; }
      .footer-links { list-style: none; }
      .footer-links li { margin-bottom: 10px; }
      .footer-links a { font-size: 14px; color: #94a3b8; transition: var(--transition); }
      .footer-links a:hover { color: white; padding-left: 4px; }
      .footer-contact { display: flex; flex-direction: column; gap: 12px; }
      .footer-contact-item { display: flex; align-items: flex-start; gap: 10px; font-size: 14px; color: #94a3b8; }
      .footer-contact-item svg { margin-top: 2px; color: var(--accent); flex-shrink: 0; }
      .footer-bottom { max-width: 1180px; margin: 40px auto 0; padding: 20px 24px; border-top: 1px solid var(--dark-2); display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
      .footer-bottom p { font-size: 13px; color: #64748b; }
      .footer-badge { display: inline-flex; align-items: center; gap: 6px; background: var(--dark-2); padding: 6px 14px; border-radius: 999px; font-size: 12px; color: #94a3b8; }
      @media (max-width: 900px) {
        .footer-grid { grid-template-columns: 1fr 1fr; gap: 32px; }
      }
      @media (max-width: 600px) {
        .footer-grid { grid-template-columns: 1fr; gap: 28px; }
        .footer-bottom { flex-direction: column; text-align: center; }
      }
    `}</style>

    <div className="footer-grid">
      <div className="footer-brand">
        <div className="footer-logo">
          <div className="footer-logo-icon">K</div>
          Korpnex
        </div>
        <p className="footer-tagline">
          Industry-ready training programs for college students and freshers. Launch your tech career in 2–3 months.
        </p>
        <div className="footer-socials">
          <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="footer-social"><FiLinkedin size={16} /></a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" className="footer-social"><FiInstagram size={16} /></a>
          <a href="https://twitter.com" target="_blank" rel="noreferrer" className="footer-social"><FiTwitter size={16} /></a>
          <a href="https://youtube.com" target="_blank" rel="noreferrer" className="footer-social"><FiYoutube size={16} /></a>
        </div>
      </div>

      <div className="footer-col">
        <h4>Programs</h4>
        <ul className="footer-links">
          <li><Link to="/courses/full-stack-web-development">Full Stack Development</Link></li>
          <li><Link to="/courses/data-science-ai">Data Science & AI</Link></li>
          <li><Link to="/courses/digital-marketing">Digital Marketing</Link></li>
          <li><Link to="/apply">Apply Now</Link></li>
        </ul>
      </div>

      <div className="footer-col">
        <h4>Company</h4>
        <ul className="footer-links">
          <li><Link to="/">About Us</Link></li>
          <li><Link to="/">Placement Partners</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li><Link to="/">Privacy Policy</Link></li>
          <li><Link to="/">Terms of Service</Link></li>
          <li><Link to="/">Refund Policy</Link></li>
        </ul>
      </div>

      <div className="footer-col">
        <h4>Get in Touch</h4>
        <div className="footer-contact">
          <div className="footer-contact-item"><FiMail size={15} /><span>hello@korpnex.online</span></div>
          <div className="footer-contact-item"><FiPhone size={15} /><span>+91 98765 43210</span></div>
          <div className="footer-contact-item"><FiMapPin size={15} /><span>Bengaluru, Karnataka, India — 560001</span></div>
        </div>
      </div>
    </div>

    <div className="footer-bottom">
      <p>© {new Date().getFullYear()} Korpnex EdTech  All rights reserved.</p>
      <div className="footer-badge">🔒 Secured by Razorpay · SSL Encrypted</div>
    </div>
  </footer>
);

export default Footer;
